module.exports = {
    "name": { type: 'string' },
    "namespace": { type: 'string' },
    "data": { type: 'object' },
	"stringData": { type: 'object' },
	"type": { type: 'string' }
};